import {Trans} from '@lingui/macro';
import React from 'react';

import {ApplicationEntryPointTypesEnum} from '../models/api/applicationEntryPointModel';
import {
  LocalApplicationChannelTypeComposerTypesEnum,
  LocalApplicationChannelTypeContactTypesEnum,
} from '../models/api/localApplicationChannelTypeModel';
import {LocalApplicationFeaturesEnum, LocalApplicationModel} from '../models/api/localApplicationModel';
import {LocalApplicationServerAuthenticationStrategiesEnum} from '../models/api/localApplicationServerModel';

/*
 * Constants.
 */

const renderedAuthStrategyMap: {[T in LocalApplicationServerAuthenticationStrategiesEnum]: React.ReactNode} =
  {
    [LocalApplicationServerAuthenticationStrategiesEnum.NONE]: (
      <Trans id="local-application-none-auth-strategy">None</Trans>
    ),
    [LocalApplicationServerAuthenticationStrategiesEnum.BASIC]: (
      <Trans id="local-application-basic-auth-strategy">Basic</Trans>
    ),
    [LocalApplicationServerAuthenticationStrategiesEnum.BEARER]: (
      <Trans id="local-application-bearer-auth-strategy">Bearer</Trans>
    ),
    [LocalApplicationServerAuthenticationStrategiesEnum.OAUTH2]: (
      <Trans id="local-application-oauth2-auth-strategy">OAuth2</Trans>
    ),
  };

const renderedChannelTypeContactsMap: {[T in LocalApplicationChannelTypeContactTypesEnum]: React.ReactNode} =
  {
    [LocalApplicationChannelTypeContactTypesEnum.CUSTOM]: (
      <Trans id="local-application-channel-type-contact-type-custom">Custom</Trans>
    ),
    [LocalApplicationChannelTypeContactTypesEnum.EMAIL]: (
      <Trans id="local-application-channel-type-contact-type-email">Email</Trans>
    ),
    [LocalApplicationChannelTypeContactTypesEnum.PHONE]: (
      <Trans id="local-application-channel-type-contact-type-phone">Phone</Trans>
    ),
  };

const renderedChannelTypeComposerMap: {[T in LocalApplicationChannelTypeComposerTypesEnum]: React.ReactNode} =
  {
    [LocalApplicationChannelTypeComposerTypesEnum.BASIC]: (
      <Trans id="local-application-channel-type-composer-type-basic">Basic</Trans>
    ),
    [LocalApplicationChannelTypeComposerTypesEnum.ADVANCED]: (
      <Trans id="local-application-channel-type-composer-type-advanced">Advanced</Trans>
    ),
  };

/*
 * Helpers.
 */

export function computeIsLocalApplicationFeatureActive(
  feature: LocalApplicationFeaturesEnum,
  application: LocalApplicationModel,
) {
  switch (feature) {
    case LocalApplicationFeaturesEnum.INBOX_SIDEPANEL:
      return Boolean(
        application.entryPoints?.items.some(
          (e) => e.type === ApplicationEntryPointTypesEnum.INBOX_SIDE_PANEL,
        ),
      );
    case LocalApplicationFeaturesEnum.CHANNEL:
      return Boolean(application.channelType);
    default:
      return false;
  }
}

export function renderLocalApplicationServerAuthenticationConfigStrategy(
  type: LocalApplicationServerAuthenticationStrategiesEnum,
) {
  return renderedAuthStrategyMap[type];
}

export function renderLocalApplicationChannelTypeContactType(
  type: LocalApplicationChannelTypeContactTypesEnum,
) {
  return renderedChannelTypeContactsMap[type];
}

export function renderLocalApplicationComposerTypeContactType(
  type: LocalApplicationChannelTypeComposerTypesEnum,
) {
  return renderedChannelTypeComposerMap[type];
}
